<template>
  <div class="user-role">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item v-if="funcView.user_role_bind || !!orgId">
          <el-button type="primary" :disabled="!userId" icon="el-icon-plus" @click="openBindRole()">
            {{ $t('base_user_role.shou_yu_gang_wei') }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.user_role_unbind || !!orgId">
          <el-button type="primary" icon="el-icon-minus" :disabled="!userId || !tableSelect.length" @click="unBindAllRoleConfirm">
            {{ $t('base_user_role.shou_hui_gang_wei') }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_user_role.gang_wei_ming_cheng')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table type="checkbox" tableCode="user_role" v-model="tableSelect" :data="userRoleList" @column="setColumn" @filter="filterChange" @sort="sortChange">
        <el-table-column :label="$t('Common.com_handle')" fixed="right">
          <template slot-scope="scope" v-if="funcView.user_role_unbind || !!orgId">
            <el-button type="text" size="mini" @click="unBindRoleConfirm(scope.row)">
              {{ $t('base_user_role.shou_hui') }}
            </el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 关联岗位弹窗 -->
    <user-role-bind-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getUserRolePage()"></user-role-bind-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import userRoleBindDialog from './user_role_bind_dialog';

export default {
  components: { userRoleBindDialog },
  props: {
    userId: {
      type: [String, Number, Boolean],
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    orgId: [String, Number]
  },
  data() {
    return {
      tableSelect: [],
      formSearch: {
        search: '',
        bizId: '',
        isAssociated: 1,
        pageSize: 20,
        pageNum: 1
      },

      dialogVisible: false,
      dialogModel: {},

      userRoleList: [],
      totalRows: 0,
      isLoading: false
    };
  },
  watch: {
    userId: function () {
      this.resetFormSearch = JSON.stringify(this.formSearch);
      this.getUserRolePage();
    }
  },
  mounted() {
    this.getFuncView('/company/user');
    this.getUserRolePage();
  },
  methods: {
    // 获取用户岗位列表
    getUserRolePage: function () {
      if (!this.userId) {
        this.userRoleList = [];
        this.totalRows = 0;
        return;
      }
      this.formSearch.bizId = this.userId;
      this.isLoading = true;
      this.$getJSON(apis.UserRolePage, this.formSearch).then((res) => {
        this.isLoading = false;
        this.userRoleList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getUserRolePage();
    },
    // 批量取消关联确认
    unBindAllRoleConfirm: function () {
      this.$showConfirm(this.$t('base_user_role.nqdyshxzdgwm'))
        .then(() => {
          const roleIds = this.tableSelect.map(t => t.roleId);
          this.unBindRole({
            bizId: this.userId,
            bizName: this.userName,
            bizType: 3,
            roleIds: roleIds
          });
        })
        .catch(() => {});
    },
    // 取消关联确认
    unBindRoleConfirm: function (item) {
      this.$showConfirm(this.$t('base_user_role.nqdyshxzdgwm'))
        .then(() => {
          this.unBindRole({
            bizId: this.userId,
            bizName: this.userName,
            bizType: 3,
            roleIds: [item.roleId]
          });
        })
        .catch(() => {});
    },
    // 取消关联提交
    unBindRole: function (params) {
      this.$postJSON(apis.UserRoleUnbind, params).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getUserRolePage();
      });
    },
    // 关联角色弹窗
    openBindRole: function () {
      this.dialogModel.title = this.$t('base_user_role.shou_yu_gang_wei');
      this.dialogModel.data = { userId: this.userId, userName: this.userName, orgId: this.orgId };
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="scss"></style>
